import { QueryKey, useQuery } from "@tanstack/react-query";
import { projectApi } from "../api/project";
import { queryClient } from "../../../shared/providers/QueryProvider";

export interface UseStagesProps {
  searchKey: string;
  portfolioId: string | undefined;
  isPinned: boolean;
  isArchived: boolean;
  quickFilters: {
    region: string[] | null;
    programme: string[] | null;
    site: string[] | null;
    workstream: string[] | null;
    "worktype-group": string[] | null;
    projectYear: string[] | null;
    my_tasks: boolean;
    stakeholder: string[] | null;
    status: string[] | null;
  };
}

export const useStages = ({ searchKey, portfolioId, isPinned, isArchived, quickFilters }: UseStagesProps) => {

    const { data, isLoading, isError, refetch } = useQuery({
      queryKey: [
        "project-listing-stages",
        searchKey,
        portfolioId,
        isPinned,
        isArchived,
        quickFilters["region"],
        quickFilters["programme"],
        quickFilters["site"],
        quickFilters["workstream"],
        quickFilters["worktype-group"],
        quickFilters["projectYear"],
        quickFilters["my_tasks"],
        quickFilters["stakeholder"],
        quickFilters["status"],
      ] as QueryKey,
      queryFn: () =>
        projectApi.fetchProjectStages({
          search_term: searchKey,
          portfolio_id: portfolioId,
          region_id: quickFilters["region"],
          programme_id: quickFilters["programme"],
          site_id: quickFilters["site"],
          workstream_id: quickFilters["workstream"],
          work_type_group_id: quickFilters["worktype-group"],
          project_year: quickFilters["projectYear"],
          assign_to_me: quickFilters.my_tasks,
          stakeholder_id: quickFilters.stakeholder,
          status: quickFilters["status"],
          ...(isPinned && { is_pinned: isPinned }),
          ...(isArchived && { is_archived: isArchived})
        }),
    });

    return {
        stagesData: data?.data || [],
        isLoading,
        isError,
        refetch,
        removeCache: () => { queryClient.removeQueries({ queryKey: ["project-listing-stages"] }); },
        removeCachePinned: () => { queryClient.removeQueries({ queryKey: ["project-listing-stages"] }); },
        removeCacheUnpinned: () => { queryClient.removeQueries({ queryKey: ["project-listing-stages"] }); }
    };

}